/**
 * Analytics Service
 *
 * Fire-and-forget event tracking via Cloudflare Worker → D1.
 * In dev mode, events are logged to console only.
 * A failed analytics call NEVER breaks the app.
 */

// PROD: use relative /api path — see BACKEND_URL in app.config.ts for proxy rationale
const ANALYTICS_URL = import.meta.env.PROD
  ? '/api/analytics/event'
  : null;

const SESSION_ID = (() => {
  let id = sessionStorage.getItem('looperc_session');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('looperc_session', id);
  }
  return id;
})();

export const sessionStartTime = Date.now();
export let loopCount = 0;

export function incrementLoopCount(): void {
  loopCount++;
}

export function track(event: string, properties: Record<string, unknown> = {}, user_id?: string): void {
  if (import.meta.env.DEV) {
    console.log('[Analytics]', event, properties);
    return;
  }

  if (!ANALYTICS_URL) return;

  fetch(ANALYTICS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event, properties, session_id: SESSION_ID, ...(user_id ? { user_id } : {}) }),
  }).catch(() => {
    // Silently swallow — analytics must never break the app
  });
}
